import React from 'react';
import { Input } from 'antd';

const JexlSelector = ({ onValueChange, value }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'baseline',
    }}
  >
    <Input
      style={{ width: '100%' }}
      onChange={(e) => onValueChange(e.target.value)}
      value={value || ''}
      placeholder="Enter a JEXL expression"
    />
  </div>
);

export default JexlSelector;
